import { createFileRoute } from '@tanstack/react-router';

import { PlanPage } from '@/features/setting/page/plan-page';

export const Route = createFileRoute('/workspace/$workspaceId/settings/plan')({
  component: RouteComponent,
});

function RouteComponent() {
  return <PlanPage />;
}
